import React from "react";
import "./footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <p>📚 Built by <a href="https://github.com/Elmari121">Elmari Robberts</a> Open-sourced on 
      <a href="https://github.com/Elmari121/dictionary-app">Github</a>
      and hosted on <a href="https://wordplay-dictionary-app.netlify.app/">Netlify</a> Data from Dictionary API & Pexels</p>
    </footer>
  );
}
